// alert(2)

// Check if debug mode is enabled (global)

// TRAN removed - use TranslationRegistry instead
// window.TRAN is now populated by TranslationRegistry

var TA_BLUR=false

			// copy & tweak from core
const cmp = new Intl.Collator('en').compare;
const typeAHeadSort = (info, haystack, needle) => {
    let {
        idx,
        chars,
        terms,
        interLft2,
        interLft1,
    //	interRgt2,
    //	interRgt1,
        start,
        intraIns,
        interIns,
    } = info;

    return idx.map((v, i) => i).sort((ia, ib) => (
        // most contig chars matched
        chars[ib] - chars[ia] ||
        // least char intra-fuzz (most contiguous)
        intraIns[ia] - intraIns[ib] ||
        // earliest start of match
        start[ia] - start[ib] ||
        // shortest match first
        haystack[idx[ia]].length - haystack[idx[ib]].length ||
        // most prefix bounds, boosted by full term matches
        (
            (terms[ib] + interLft2[ib] + 0.5 * interLft1[ib]) -
            (terms[ia] + interLft2[ia] + 0.5 * interLft1[ia])
        ) ||
        // highest density of match (least span)
    //	span[ia] - span[ib] ||
        // highest density of match (least term inter-fuzz)
        interIns[ia] - interIns[ib] ||
        // alphabetic
        cmp(haystack[idx[ia]], haystack[idx[ib]])
    ))
};

String.prototype.format = function () {
    var i = 0, args = arguments;
    l(arguments)
    return this.replace(/<!--\s*\$(\w+)\s*-->/g, function (matches) {
      if(typeof args[i] != 'undefined'){
        return args[i++]}
      else{return '';}
    });
};

Array.range = function(a, b, step){
    var A = [];
    if(typeof a == 'number'){
        A[0] = a;
        step = step || 1;
        while(a+step <= b){
            A[A.length]= a+= step;
        }
    }
    else {
        var s = 'abcdefghijklmnopqrstuvwxyz';
        if(a === a.toUpperCase()){
            b = b.toUpperCase();
            s = s.toUpperCase();
        }
        s = s.substring(s.indexOf(a), s.indexOf(b)+ 1);
        A = s.split('');        
    }
    return A;
}

// $.fn.extend({
//     prependEvent: function (event, handler) {
//       return this.each(function () {
//         var events = $(this).data("events"), 
//             currentHandler;
  
//         if (events && events[event].length > 0) {
//           currentHandler = events[event][0].handler;
//           events[event][0].handler = function () {
//             handler.apply(this, arguments);
//             currentHandler.apply(this, arguments);
//           }      
//         }
//       });
//     }
//   });

function randomIntFromInterval(min, max) { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min);
}

function deepEqual(x, y) {
    const ok = Object.keys, tx = typeof x, ty = typeof y;
    return x && y && tx === 'object' && tx === ty ? (
      ok(x).length === ok(y).length &&
        ok(x).every(key => deepEqual(x[key], y[key]))
    ) : (x === y);
}
var removeElement = function(arr,el) {
    return arr.filter(function(e) { return e !== el }) 
};

$(document).on("click", function (e) {
    let checkList=['.tt-menu','#fnd_searchbox','.filter-button']
    TA_BLUR=true
    let gotcha=false
    // l(`TA_BLUR_99=${TA_BLUR}`)
    for(let el of checkList){
        if ($(e.target).closest(el).length>0){
            // l($(e.target));l(el);l($(e.target).closest(el));l($(e.target).closest(el).length)
            TA_BLUR=false
            // l('KEEP OPENED')
            return;
        }
    }
    // l('CLOSING...')
    // l(`TA_BLUR_10=${TA_BLUR}`)
    // $("#fnd_searchbox").blur()
    
    // Close typeahead only if element exists and typeahead is initialized
    const $searchbox = $("#fnd_searchbox");
    if ($searchbox.length > 0 && typeof $searchbox.typeahead === 'function') {
        try {
            $searchbox.typeahead("close");
        } catch (e) {
            // Typeahead might not be initialized on this page (e.g., login page)
            console.debug('Typeahead not available on this page');
        }
    }
});

// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substring(0,4))) {
    const isMobile = true;
}else{const isMobile = false}

String.prototype.replaceMulti = function(mapObj2){
    // var mapObj={}
    v=this
    for(i in mapObj2){
        var re2 = new RegExp(i,"gi");
        v=v.replace(re2,mapObj2[i])
        // mapObj[i.toLowerCase()]=mapObj2[i]
    }
    return v;
}

Number.prototype.leadingZero = function(size) {
    let num = this.toString();
    while (num.length < size) num = "0" + num;
    return num;
}

class UniqueArray extends Array {
    constructor(...args) {
        super(...args);
    }
    unshiftUnique() {
        if (!super.includes(arguments[0])){
            return super.unshift(arguments[0]);
        }else{return false}
    }
    pushUnique() {
        if (!super.includes(arguments[0])){
            return super.push(arguments[0]);
        }else{return false}
    }
}


Object.defineProperty(Array.prototype, 'addUnique', {
    value: function(newItem) {if($.inArray(newItem, this)==-1){this.push(newItem)}}
});

function escapeRegExp(text) { // \s*?
    return text.replace(/(?! )[-[\]{}()+.,\\^$|#\s]/g, '\\$&');
}

function translate(text){
    if (window.TranslationRegistry && typeof window.TranslationRegistry.translate === 'function') {
        const lang = (window.LANG || 'EN').toUpperCase();
        const translation = window.TranslationRegistry.translate(text, lang);
        if (translation !== text) {
            return translation;
        }
    }
    return text;
}

// Loader translations are now in JSON files (static/js/translations/pages/search/translations.json)

function removeItemWithSlice(index) {
    return [...items.slice(0, index), ...items.slice(index + 1)]
}

function langCheckReload(lang='', LANG){
    var m=null, LANG=LANG_BROWSER
    
    // Если язык уже задан с сервера, используем его без перенаправления
    if (typeof window.LANG_FROM_SERVER !== 'undefined' && window.LANG_FROM_SERVER) {
        return window.LANG_FROM_SERVER;
    }
    
    if (lang==''){
        m=window.location.href.match(/https?:\/\/[^\/]+\/([a-z]{2})\//)
        if(m!==null){
            LANG=m[1].toUpperCase()
        }
    }
    if(lang!='' || m===null){
        const targetLang = (lang!=''?lang:LANG).toLowerCase();
        
        // Используем LanguageManager если доступен (сохраняет hash и query)
        if (window.LanguageManager && typeof window.LanguageManager.getLanguageUrl === 'function') {
            const newHref = window.LanguageManager.getLanguageUrl(targetLang);
            if (newHref !== window.location.href) {
                window.location.href = newHref;
            }
        } else {
            // Fallback: сохраняем hash и query параметры вручную
            const hash = window.location.hash || '';
            const search = window.location.search || '';
            const currentHref = window.location.href;
            
            // Извлекаем путь без hash и query
            const pathMatch = currentHref.match(/https?:\/\/[^\/]+(\/[^?#]*)/);
            let pathWithoutLang = pathMatch ? pathMatch[1] : '/';
            
            // Убираем префикс языка если есть
            pathWithoutLang = pathWithoutLang.replace(/^\/[a-z]{2}(\/|$)/, '/');
            if (!pathWithoutLang.startsWith('/')) {
                pathWithoutLang = '/' + pathWithoutLang;
            }
            
            // Формируем новый URL с сохранением всех частей
            const newPathname = '/' + targetLang + pathWithoutLang;
            const newHref = window.location.origin + newPathname + search + hash;
            
            if (newHref !== currentHref) {
                window.location.href = newHref;
            }
        }
    }
    return LANG;
}

String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
}

function resetAccountAutocompletion(typeaheadObject) {

    
    // Simple version like in old working code
    if (!typeaheadObject || !typeaheadObject.length || typeof typeaheadObject.typeahead !== 'function') {

        return;
    }
    
    // CRITICAL: Initialize cachedRequest if not available
    if (typeof cachedRequest === 'undefined') {
        window.cachedRequest = { 'request': '  ', 'filterUpdate': true, 'mCondPrev': [], 'mCond': [] };
    }
    
    var oldVal = typeaheadObject.val();

    
    typeaheadObject.typeahead("val", "FILTERS_UPDATE");
    cachedRequest['filterUpdate'] = true;
    typeaheadObject.typeahead("val", oldVal);
    

};

function unzip(input){
    let compressedData = Uint8Array.from(atob(input), (c) => c.charCodeAt(0));
    let decompressedData = pako.inflate(compressedData, { to: "string" });
    return jsonObject = JSON.parse(decompressedData);
}

function b64dec(encoded) {
    return Base64.decode(encoded);
}

function lastModified(uri, cachedDate){
    let ret = null;
    try {
        const headers = {};
        // Send If-Modified-Since header if we have cached date
        if (cachedDate) {
            const dateStr = new Date(cachedDate).toUTCString();
            headers['If-Modified-Since'] = dateStr;
        }
        
        $.ajax({url: uri, type:"HEAD", async: false, headers: headers}).done((d, s, xhr) => {
            // If server returned 304, data hasn't changed - return cached date
            if (xhr.status === 304 && cachedDate) {
                ret = cachedDate;
                return;
            }
            
            const lastModHeader = xhr.getResponseHeader("Last-Modified");
            ret = lastModHeader ? Date.parse(lastModHeader) : null;
        }).fail((xhr, s, err) => {
            // If 304 Not Modified, use cached date
            if (xhr.status === 304 && cachedDate) {
                ret = cachedDate;
                return;
            }
            
            console.log('Error getting file:'+s)
            ret = null
        })
    } catch (error) {
        if (debugMode === '1') {
                if (debugMode === '1') {
                console.log('Error in lastModified:', error);
            }
            }
        ret = null;
    }
    return ret;
}


const sklonenie = (number, txt, cases = [2, 0, 1, 1, 1, 2]) => txt[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];

function sklon(cnt,opts,proper=0){
    switch(window.LANG) {
        case 'RU':
            ret=sklonenie(cnt, ['', opts[0][0], opts[0][1]])
            break;
        case 'EN':
            ret=sklonenie(cnt, ['', opts[1], opts[1]])
            break;
        case 'DE':
            ret=sklonenie(cnt, ['', opts[2], opts[2]])
            break;
        default:
            ret=sklonenie(cnt, ['', opts[1], opts[1]])
    }
    return (proper==0 ? ret : ret.toProperCase());
}

function l(t){console.log(t)}

function isNumeric(str) {
    if (typeof str != "string") return false ;// we only process strings!  
    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
           !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}
function isInt(str) {
    if (typeof str != "string") return false ;// we only process strings!  
    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
           !isNaN(parseInt(str)) // ...and ensure strings of whitespace fail
}
function getParamArray(url) {
    var queryString = url.substring(1);
    return queryString.split('&').map(function(sParam) {
      var param = sParam.split('=');
    //   l(param)
      return {
        name: decodeURIComponent(param[0]),
        value: param[1] ? decodeURIComponent(param[1].replace(/\+/g, ' ')) : ''
      };
    });
}


function sort_array_based_on_example(sort_array, example_array){
    sort_array.sort((x, y)=>
        (example_array.indexOf(x)==-1 ? 10 : example_array.indexOf(x)) - (example_array.indexOf(y)==-1 ? 10 : example_array.indexOf(y))
    );
}
function sort_array_keys_based_on_example(sort_array, example_array){
    ks=Object.keys(sort_array).sort((x, y)=>
        (example_array.indexOf(x)==-1 ? 10 : example_array.indexOf(x)) - (example_array.indexOf(y)==-1 ? 10 : example_array.indexOf(y))
    );
    ks2=ks.reduce(
        (obj, key) => { 
          obj[key] = sort_array[key]; 
          return obj;
        }, 
        {}
    );
    return ks2;
}

// function cartesianProductOf() {
//     return _.reduce(arguments, function(a, b) {
//         return _.flatten(_.map(a, function(x) {
//             return _.map(b, function(y) {
//                 return x.concat([y]);
//             });
//         }), true);
//     }, [ [] ]);
// }
function cartesianProduct(arr) {
    return arr.reduce((a, b) =>
      a.map(x => b.map(y => x.concat(y)))
      .reduce((a, b) => a.concat(b), []), [[]]);
}
function capitalizer(string) {
    return string.split(/\s/).map(function(item){
      return (item.charAt(0).toUpperCase() + item.slice(1))
    }).join(' ');
  }
function T(t,proper=0){
    const lang = (window.LANG || 'EN').toUpperCase();
    let ret = t;
    if (window.TranslationRegistry && typeof window.TranslationRegistry.translate === 'function') {
        ret = window.TranslationRegistry.translate(t, lang);
    }
    return (proper==0 ? ret : capitalizer(ret.toProperCase()));
} // Translation short function

function objectFlip(obj) {
    const ret = {};
    Object.keys(obj).forEach(key => {
      ret[obj[key]] = key;
    });
    return ret;
}

$( document ).ready(function() {
    $.urlParam = function(name){
        let object = getParamArray(window.location.search);
        let results=[]
        for (let i = 0; i < object.length; i++) {
            let key=object[i]['name'];
            let value=object[i]['value'];
            let is_array=/\[\]$/.test(key);
            if(is_array){key=key.replace(/\[\]$/g,'');}
            if(key==name){
                if(is_array){if (typeof results === 'undefined') {results=[];}results.push(isInt(value) ? parseInt(value) : value);
                }else{results=value;break;}
            }
        }
        // l(results)
        //alert(window.location.href);
        // Absent param used to leak as [] (empty array — TRUTHY!), which downstream
        // truthiness checks treated as a present value (real bug: phantom "2" on the
        // filter badge from dateFrom/dateTo = []). Absent/empty => null.
        if (Array.isArray(results) && results.length === 0) return null;
        return results;
    }
    
});


function onDropDownChange(k,sel,trees){

    decart=[];
    // l('k='+k+'; sel='+sel)
    //Формируем шаблоны для сверки с дропнаунами, в которых еще не выбраны элементы
    // let other=false
    for (const [k2,tree] of Object.entries(trees)) {
        // if(trees['S'].value.length>0){
        //     if(trees['S'].value[0]=='Other'){other=true}
        // }
        if(tree.value.length>0){
            // if(k2=='S' && other){continue}
            tmp=[]
            for (f in tree.value){
                tmp.push(tree.value[f]+':'+k2);
            }                                
            decart.push(tmp);
        }else{
            decart.push(['']);
        }
    }
    decart=cartesianProduct(decart);
    // l(decart)
    // Проходим все дропдауны
    // var OTHER_CLICK= (k=='S' && $.inArray('Other',sel) !== -1)
    // if(OTHER_UNCLICK){l('UNCLICK')}
    // if(OTHER_CLICK){
        // for (i in trees['S'].options){
        //     opt=trees['S'].options[i].value;
        //     if(opt!='Other'){
        //         trees['S'].options[i].disabled=true;
        //     }
        // }
        // trees['S'].mount();
    // }else{

        // if(k=='S'){
        //     for (i in trees['S'].options){
        //         trees['S'].options[i].disabled=false;
        //     }
        //     // trees['S'].mount();
        // }

        // l(decart);
        index=0;
        for (const [k2,tree] of Object.entries(trees)) {
            // Если в дропдауне не выбраны элементы, то обрбатываем, ищем доступные для выбора 
            if(k!=k2){ // || $.inArray('Other',window.prev_sel) !== -1){
                // l('test');
                // Залезли в элементы дропдауна
                for (i in tree.options){
                    // tree.options[i].disabled= (tree.options[i].value=='Other' && k2=='S') ? false : (other ? false : true);
                    tree.options[i].disabled= true;
                    // Перебираем шаблоны для сравнения
                    for (i2 in decart){
                        option=tree.options[i]['value']+':'+k2;
                        pattern=decart[i2].slice();
                        pattern[index]=option
                        re_text="^"+pattern.join('.*')+"$"
                        let re = new RegExp(re_text, 'g');
                        //if(k2=='T'){l('re_text='+re_text+'; option='+option);}
                        for (const [cat,id] of Object.entries(CATEG)) {
                            // if(k2=='T'){l(cat);}
                            let isMatch = re.test(cat); 
                            if(isMatch) {
                                // let att = document.createAttribute("disabled");
                                // att.value = true;
                                // tree.options[i].htmlAttr=att;
                                // if(k2=='S'){l('re_text='+re_text+'; cat='+cat);}
                                tree.options[i].disabled=false;
                            }
                        }
                    }
                }
                // l(tree.options)
                // l('mnt? '+k2)
                tree.mount();
            }
            index+=1;
        }
    // }
    window.prev_sel=sel;
    

    resetAccountAutocompletion($("#fnd_searchbox"))
}

(function (factory) {
    factory(jQuery, window.Inputmask, window);
  })(function ($, Inputmask, window) {
    $(window.document)
      .ajaxComplete(function (event, xmlHttpRequest, ajaxOptions) {
        if ($.inArray("html", ajaxOptions.dataTypes) !== -1) {
          $(
            ".inputmask, [data-inputmask], [data-inputmask-mask], [data-inputmask-alias], [data-inputmask-regex]"
          ).each(function (ndx, lmnt) {
            if (lmnt.inputmask === undefined) {
              Inputmask().mask(lmnt);
            }
          });
        }
      })
      .ready(function () {
        $(
          ".inputmask, [data-inputmask], [data-inputmask-mask], [data-inputmask-alias],[data-inputmask-regex]"
        ).each(function (ndx, lmnt) {
          if (lmnt.inputmask === undefined) {
            Inputmask().mask(lmnt);
          }
        });
      });
  });

function range(start, stop, step) {
    if (typeof stop == 'undefined') {
        // one param defined
        stop = start;
        start = 0;
    }

    if (typeof step == 'undefined') {
        step = 1;
    }

    if ((step > 0 && start >= stop) || (step < 0 && start <= stop)) {
        return [];
    }

    var result = [];
    for (var i = start; step > 0 ? i < stop : i > stop; i += step) {
        result.push(i);
    }

    return result;
}